import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { usePortfolioListQuery } from "web_myplann/Api/Portfolio/Queries/usePortfolioListQuery";
import { usePropertyListQuery } from "web_myplann/Api/Portfolio/Queries/usePropertyListQuery";
import { availablePortfolioCategories } from "web_myplann/Portfolio/Helpers/availablePortfolioCategories";
import { normalizePortfolioCategories } from "web_myplann/Portfolio/Helpers/normalizePortfolioCategories";
import type { PortfolioCategoryId } from "web_myplann/Portfolio/Types/portfolioCategory";
import {
	type PortfolioFilterState,
	portfolioFilterState,
} from "web_myplann/Shared/State/portfolioFilterAtom";

type EffectivePortfolioFilter = {
	filter: PortfolioFilterState;
	availableCategories: PortfolioCategoryId[];
};

export const useEffectivePortfolioFilter = (): EffectivePortfolioFilter => {
	const storedFilter = useAtomValue(portfolioFilterState);
	const { data: portfolioList } = usePortfolioListQuery();
	const { data: propertyList } = usePropertyListQuery();

	const availableCategories = useMemo(
		() =>
			availablePortfolioCategories(
				portfolioList?.data ?? [],
				propertyList?.data ?? [],
			),
		[portfolioList?.data, propertyList?.data],
	);

	const filter = useMemo(
		() => ({
			...storedFilter,
			categories: normalizePortfolioCategories(
				storedFilter.categories,
				availableCategories,
			),
		}),
		[storedFilter, availableCategories],
	);

	return { filter, availableCategories };
};
